<template>
  <v-progress-linear
    v-if="isNavigationInProgress"
    indeterminate
    color="primary"
    height="3"
    class="navigation-progress-bar"
    aria-label="Loading page"
    data-test="navigation-progress"
  />
</template>

<script setup lang="ts">
import { isNavigationInProgress } from '@/bundles/App/helpers/navigationProgress';

// A thin bar across the top while a page is loading, so a click that waits for code never looks ignored.
</script>

<style lang="scss" scoped>
.navigation-progress-bar {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  z-index: 3000;
}
</style>
